import { render, staticRenderFns } from "./transferBalanceRecord.vue?vue&type=template&id=949900fe&scoped=true&"
import script from "./transferBalanceRecord.vue?vue&type=script&lang=js&"
export * from "./transferBalanceRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "949900fe",
  null
  
)

export default component.exports